var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"contents",fn:function(){return [_c('div',{staticClass:"tos"},[(_vm.$i18n.locale === 'ja')?_c('JpText'):_c('EnText')],1)]},proxy:true}])},'Modal',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }